/*
 * Mobile video rendition (see snippets/tuco-video-tag.liquid).
 * On screens up to 767px, videos marked with data-tuco-hls get the 720p MP4 instead of the 1080p one.
 * The 720p file name includes a bitrate that only the HLS master manifest lists, so it is read from there.
 * Runs for videos in the page and for videos created later from <template> (video-media).
 */
(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const manifests = new Map();

  const mp4FromManifest = (hlsUrl) => {
    if (!manifests.has(hlsUrl)) {
      manifests.set(hlsUrl, fetch(hlsUrl)
        .then((response) => (response.ok ? response.text() : ''))
        .then((text) => {
          // e.g. 5e81....HD-720p.4.5Mbps.hls.54446685_.m3u8 -> 5e81....HD-720p-4.5Mbps-54446685.mp4
          const lines = text.split('\n').filter((line) => line.endsWith('.m3u8'));
          const pick = lines.find((line) => line.includes('-720p.')) || lines.find((line) => line.includes('-480p.'));
          const match = pick && pick.match(/^(.+?)-(\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8$/);
          if (!match) return null;
          return new URL(`${match[1]}-${match[2]}-${match[3]}-${match[4]}.mp4`, new URL(hlsUrl, location.href)).href;
        })
        .catch(() => null));
    }
    return manifests.get(hlsUrl);
  };

  const setSource = (video) => {
    if (video.dataset.tucoSource) return;
    video.dataset.tucoSource = 'pending';
    mp4FromManifest(video.dataset.tucoHls).then((url) => {
      const source = document.createElement('source');
      source.src = url || video.dataset.tucoMp4;
      source.type = 'video/mp4';
      video.appendChild(source);
      video.dataset.tucoSource = url ? '720' : 'fallback';
      // A play() requested before the source existed resumes on its own; autoplay videos start here.
      if (!video.paused || video.autoplay) video.play().catch(() => {});
    });
  };

  const scan = (root) => {
    if (!mobile.matches) return;
    if (root.matches && root.matches('video[data-tuco-hls]')) setSource(root);
    root.querySelectorAll && root.querySelectorAll('video[data-tuco-hls]').forEach(setSource);
  };

  // Manifests are tiny, but wait for the load event so nothing competes with the main product image.
  if (document.readyState === 'complete') scan(document);
  else window.addEventListener('load', () => scan(document), { once: true });
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => node.nodeType === 1 && scan(node)));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
